import { CATEGORY_META } from "../data/menu";
import type { Category } from "./types";

const ICONS: Record<string, string> = { daily: "🍱" };
CATEGORY_META.forEach((c) => {
  ICONS[c.key] = c.icon;
});

/** Emoji used as the item/section visual anchor (no photos). */
export function categoryIcon(cat: Category | string): string {
  return ICONS[cat] ?? "🍽️";
}
